import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from '../../context/ThemeContext';
import TooltipButton from '../Tools/TooltipButton.tsx';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ToggleButton = styled.button`
  width: 45px;
  height: 20px;
  border-radius: 13px;
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  position: relative;
  cursor: pointer;
  outline: none;
  padding: 0;
`;

const ToggleCircle = styled.div`
  width: 18px;
  height: 16px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 2px;
  left: ${({ theme }) => (theme.name === 'dark' ? '26px' : '2px')};
  transition: ${({ theme }) => theme.transitions.medium} left;
`;

const ThemeToggle = () => {
  const { theme, changeTheme } = useContext(ThemeContext);

  const handleToggle = () => {
    changeTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <TooltipButton title={theme == "dark" ? "Switch to Light Theme" : "Switch to Dark Theme"}>
      <ToggleContainer className='j_h_theme'>
        <ToggleButton onClick={handleToggle}>
          <ToggleCircle />
        </ToggleButton>
      </ToggleContainer>
    </TooltipButton>
  );
};

export default ThemeToggle;